module.exports = __webpack_public_path__ + "img/2021_07_24_Music Day_Flyer.95a3fb96.jpg";